import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { iconColor } from "@/consts/iconColor";
var __default__ = {
  name: "LatestAbsenceInfo",
  components: {
    RowItem: RowItem
  },
  filters: {
    trim: function trim(value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    },
    mmdd: function mmdd(value) {
      if (!value) return "";
      value = value.toString();
      return value.slice(5);
    }
  },
  props: {
    attendances: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapState(["me"])),
  methods: {
    iconColor: iconColor
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // import { inject } from "vue";
    // const attendanceMode = inject("attendanceMode");
    // const changeAttendanceMode = () => {
    //   attendanceMode.value = "counter";
    // };
    return {
      __sfc: true,
      RowItem: RowItem,
      iconColor: iconColor
    };
  }
});